<div>
<div *ngIf="!modal">
  <div (mouseenter)="mouseOvered=true" (mouseleave)="mouseOvered=false" class="thumbnail" >
    
    <a  *ngIf="hasImages " href="javascript:void(0)" (click)="select()">
      <img [src]="currentUrl"  class="attach"
      [class.attach]="canShow" 
      [class.attach-none]="!canShow" >
    </a>


    
    <img *ngIf="!hasImages  " [src]="currentUrl" class="attach-none">

    <div class="loading" *ngIf="loading" >
      <img [style.width]="'20px'" [style.height]="'20px'" src="assets/loader1.gif" alt="">
      <!-- <i  class='glyphicon glyphicon-refresh glyphicon-refresh-animate' ></i> -->
    </div>
    <div *ngIf="(!mouseOvered || fault.Files.length==1) && hasImages " class="nav-menu" style="background-color:transparent">
        <span class="badge pull-right" style="background-color: #98bae0; color:black; font-weight:normal;">{{fault.Files.length}}</span>
    </div>
    <div class="nav-menu" *ngIf="mouseOvered && hasImages &&  fault.Files.length>1" >
      <a class="btn btn-link btn-xs pull-left" [class.disabled]="!canPrevious" href="javascript:void(0)" (click)="showPrevious()">
        <span class="glyphicon glyphicon-menu-left"></span>
      </a>
      <span style="user-select:none">{{countText}}</span>
      <a class="btn btn-link btn-xs pull-right" [class.disabled]="!canNext" href="javascript:void(0)" (click)="showNext()">
        <span class="glyphicon glyphicon-menu-right"></span>
      </a>
    </div>
  </div>

</div>
<div *ngIf="modal">

    <div class="modal-overlay" *ngIf="isModalOpened">
        <div class="modal-content" >
        
        <img *ngIf="loading" class="modal-img"  style="z-index:1; position:absolute; left:0px;right:0px" src="assets/loader1.gif" alt="">
      
        <div class="info-text info-top" >
            <span class="opacity-bgr">{{title}}</span>
         </div>

        <a class="close-popup" (click)="closeModal()"><i class="glyphicon glyphicon-remove opacity-bgr"></i></a>
        <a class="nav-left" *ngIf="canPrevious" (click)="showPrevious()"><i class="glyphicon glyphicon-menu-left opacity-bgr"></i></a>    
            <img  [src]="currentUrl" (click)="showNext()" class="modal-img effect" />
            <div *ngIf="canDownload"   class="modal-btn">
              <button href="javascript:void(0)" [disabled]="loading"     
                 class="btn btn-primary floating" (click)="download()" >
                <span class="glyphicon glyphicon-cloud-download"></span> 
                <span *ngIf="currentAttachement">{{ 'weblink.button.download' | translate }}</span>
            </button>
            </div>
         <a class="nav-right" *ngIf="canNext" (click)="showNext()"><i class="glyphicon glyphicon-menu-right opacity-bgr"></i></a>
         <div class="info-text info-bottom">
           <span class="opacity-bgr">{{countText}}</span>
        </div>
       
      </div>
    </div>
  
  </div>
  </div>